<template>
<span>
  <q-input 
  class="dstyle"
  v-model="showDate" 
  :label="label"
  ref="qInput"
  :error="!isValid"
  error-messageX= "No Valid Date Message, not active to reduce height "
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale" >
          <q-date v-model="selectDate" @input="() => $refs.qDateProxy.hide()" />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</span>
</template>

<script>
export default {
  name: 'InputDate',
  data () {
    return {
      selectDate: this.date.format('YYYY/MM/DD'),
      dformat: this.$store.state.session.DateTimeFormat.substring(0,10),
      showDate: this.moment(this.date).format(this.$store.state.session.DateTimeFormat.substring(0,10)),
      isValid: true
    }
  },
  methods: {
    
  },
  created () {
    
  },
  computed: {

  
  },
  watch: {
    selectDate: function (val) {
      this.showDate = this.moment(val, 'YYYY/MM/DD').format(this.dformat)
      this.$emit('update:date', this.moment(val, 'YYYY/MM/DD'))
    },
    showDate: function (val) {
      var date = this.moment(val, this.dformat, true)
      if(date.isValid()){
        this.isValid = true
        this.$emit('update:date', date)
      }
      else
        this.isValid = false
    }
  },
  props: ['date','label'],
}
</script>
<style scoped>
.dstyle{
  height: 30px;
}
</style>